{
  "nl": {
    "dashboard": {
      "greetings": {
        "afternoon": "Goedemiddag {first_name}",
        "evening": "Goedenavond {first_name}",
        "morning": "Goedemorgen {first_name}",
        "night": "Goedenacht {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "Je hebt momenteel geen openstaande items.",
        "caught_up_title": "Je bent helemaal bij",
        "completed_count": "{count} voltooid",
        "due_before": "Vóór {date}",
        "journey_no_active_subtitle": "Deze unit is nog niet aan zijn traject begonnen.",
        "journey_no_active_title": "Geen actieve mijlpaal",
        "journey_select_unit_subtitle": "Kies hierboven een unit om het traject te bekijken.",
        "journey_select_unit_title": "Selecteer een unit",
        "journey_title": "Jouw traject",
        "open_action": "Openen",
        "previous_label": "Eerdere mijlpalen",
        "progress_completed": "{completed} / {total} voltooid",
        "show_less": "Minder tonen",
        "show_more_tasks": "Nog {count} taak tonen | Nog {count} taken tonen",
        "status_active": "Bezig",
        "status_completed": "Voltooid",
        "status_planned": "Gepland",
        "todo_now_title": "Wat nu te doen",
        "upcoming_more": "Nog {count} komende mijlpalen"
      },
      "titles": {
        "activityFeed": "Activiteiten",
        "assignedTasks": "Mijn Taken",
        "newsFeed": "Nieuwsoverzicht",
        "ongoingTickets": "In Behandeling",
        "openTickets": "Open",
        "progress": "Voortgang",
        "tickets": "Gesprekken",
        "totalTickets": "Alle gesprekken",
        "unreadTickets": "Ongelezen",
        "yourAssignedTickets": "Aan jou toegewezen"
      }
    }
  }
}
